export default "__VITE_ASSET__BjorlZDy__"